import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, inject } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { IAddressData } from '@df/session/api/address-book/address';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'address-short',
    template: '<div [innerHTML]="addressString"></div>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressShortComponent implements OnChanges, OnDestroy {
    /**
     * Default image
     */
    @Input()
    address?: IAddressData;

    @Input()
    trigger?: Observable<void>;

    private triggerSubscription?: Subscription;

    private changeDetectorRef = inject(ChangeDetectorRef);
    private timeoutService = inject(TimeoutService);

    get addressString(): string {
        const address = this.address;
        if (address) {
            return [
                [
                    [address.prefix, address.firstname, address.lastname].filter(i => !!i).join(' '),
                    [address.street_1, address.street_2, address.city, address.postcode].filter(i => !!i).join(', '),
                    address.country_id
                ]
                    .filter(i => !!i)
                    .map(i => (typeof i === 'string' ? i.replace(' ', '&nbsp;') : i))
                    .join(', ')
            ]
                .filter(i => !!i)
                .join(' ');
        }
        return '';
    }

    ngOnChanges(changes) {
        if (changes.trigger) {
            this.triggerSubscription?.unsubscribe();
            this.triggerSubscription = this.trigger?.subscribe(() => {
                this.timeoutService.setTimeout(() => this.changeDetectorRef.detectChanges(), 100);
            });
        }
    }

    ngOnDestroy() {
        this.triggerSubscription?.unsubscribe();
    }
}
